<template>
  <v-card>
    <ODialogBar no-close title="Tokens">
      <v-btn icon class="ml-1" @click="reload">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-btn icon class="ml-2" @click="copyToClipboard">
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
      <v-spacer />
      <v-btn color="primary" @click="openTokensDialog">
        Criar...
      </v-btn>
    </ODialogBar>

    <OLoadingLine absolute :value="isLoading" />

    <ODataTable :spec="spec" :items="rows" />

    <v-dialog v-model="showingDialog" :width="400">
      <v-card>
        <v-toolbar class="card-bar">
          <v-toolbar-title>Criar Tokens</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-4">
          Selecione os sistemas (apps) para os quais criar tokens:
          <v-checkbox
            v-model="selectedApps"
            v-for="App in allApps"
            :key="App.code"
            :label="App.code"
            :value="App.code"
            single-line
            hide-details
          />
        </v-card-text>
        <ODialogButtons
          class="pa-4"
          @cancel="showingDialog = false"
          @apply="createTokens"
        />
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { Token } from '@/models'

export default {
  components: {
    OLoadingLine: require('oderon-vue/cpts/OLoadingLine').default,
    ODataTable: require('oderon-vue/cpts/ODataTable').default,
    ODialogButtons: require('oderon-vue/cpts/ODialogButtons').default
  },
  props: {
    org: { required: true }
  },
  computed: {
    isDev() {
      return window.location.hostname == 'localhost'
    },
    allApps() {
      return this.isDev ? this.devApps : this.prdApps
    }
  },
  data() {
    return {
      isLoading: false,
      showingDialog: false,
      rows: [],
      spec: [
        { t: 'Token', d: 'code' },
        { t: 'Subject', d: 'subject' },
        { t: 'App', d: 'app' },
        { t: 'Created', d: 'createdAt' },
        { t: 'Expires', d: 'expiresAt' }
      ],

      prdApps: [
        { code: 'beeper', url: 'http://beeper.prd.odvpc:8081' },
        { code: 'bucketman', url: 'http://bucketman.prd.odvpc:8082' },
        { code: 'excelman', url: 'http://excelman.prd.odvpc:9008' },
        { code: 'gateman', url: 'http://gateman.prd.odvpc:8099' },
        { code: 'geoman', url: 'http://geoman.prd.odvpc:9007' },
        // {code: 'mirrorman', url: 'http://mirrorman.prd.odvpc:8080'},
        { code: 'paperman', url: 'http://paperman.prd.odvpc:9004' }
      ],

      devApps: [
        { code: 'beeper-dev', url: 'http://localhost:8081' },
        { code: 'bucketman-dev', url: 'http://localhost:8082' },
        { code: 'excelman-dev', url: 'http://localhost:9008' },
        { code: 'gateman-dev', url: 'http://localhost:8099' },
        { code: 'geoman-dev', url: 'http://localhost:9007' },
        // {code: 'mirrorman-dev', url: 'http://localhost:8080'},
        { code: 'paperman-dev', url: 'http://localhost:9004' }
      ],

      selectedApps: []
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      let res = await Token.findAll({ subject: this.org.name })
      this.rows = res.rows
    },

    async openTokensDialog() {
      this.selectedApps = []
      this.showingDialog = true
    },

    async createTokens() {
      this.showingDialog = false
      this.$loading(async () => {
        for (let app of this.selectedApps) {
          await Token.save({
            subject: this.org.name,
            app,
            expiresAt: new Date('2100-01-01T00:00:00')
          })
        }

        await this.fetchData()
      })
    },

    async copyToClipboard() {
      let lines = this.rows.map((row) => {
        let app = this.allApps.find((a) => a.code == row.app)
        let appName = app.code.replace(/-dev$/, '')
        return `${appName.padEnd(16)} : ${row.code} @ ${app.url}`
      })

      navigator.clipboard.writeText(lines.join('\n'))
    }
  }
}
</script>
